export default "__VITE_ASSET__D5Q_hoEy__"